import { Card, CardContent } from "@/components/ui/card"
import { kpis, refillsOverTime } from "../-data/fixtures"
import { ChartContainer } from "@/components/ui/chart"
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts"

export default function Refills() {
  return (
    <Card className="rounded-2xl">
      <CardContent className="p-4">
        <div className="flex items-center">
          <div>
            <div className="text-xs text-muted-foreground">Refills</div>
            <div className="text-2xl font-semibold flex items-center gap-2">
              {kpis.refills.total.toLocaleString()}
              <span className="text-green-600 text-xs">↗ {kpis.refills.deltaPct}%</span>
            </div>
          </div>
        </div>
        <div className="mt-2">
          <div className="text-sm text-black mb-1">Refills over time</div>
          <ChartContainer config={{ value: { label: "Refills", color: "#2aa198" } }} className="w-full h-64 aspect-auto">
            <BarChart data={refillsOverTime}>
              <CartesianGrid vertical={false} />
              <XAxis dataKey="month" tickLine={false} axisLine={false} />
              <YAxis hide />
              <Bar dataKey="value" fill="var(--color-value)" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ChartContainer>
        </div>
      </CardContent>
    </Card>
  )
}